export const LOAD_PHOTOS = "LOAD_PHOTOS";
export const LOAD_PHOTOS_SUCCESS = "LOAD_PHOTOS_SUCCESS";
export const LOAD_PHOTOS_FAILURE = "LOAD_PHOTOS_FAILURE";
